import React from 'react'
import InputFieldUI from './InputFieldUI'
import DefaultEditor, { Editor, EditorProvider } from 'react-simple-wysiwyg'
import './InputHtmlText.css'
import CustomEditor from '../customEditor';

const InputHtmlTextUI = ({ context, type, name, value, onChange,
  // label
  label, help, height, messageList, labelKey, helpKey,
  // behavior
  required, autoFocus, disabled, error, withToolbar }) =>
  <InputFieldUI className='w_input_txtarea' name={name} required={required}
    label={label} help={help} messageList={messageList} labelKey={labelKey} helpKey={helpKey}>
    {
      !withToolbar &&
      <EditorProvider>
        <Editor value={value} onChange={onChange} containerProps={{ style: { height: height ? height : 500, overflow: 'auto' } }} />
      </EditorProvider>
    }
    {
      withToolbar &&
      /*<DefaultEditor value={value} onChange={onChange} containerProps={{ style: { height: height ? height : 500, overflow: 'auto' } }} />*/
        <CustomEditor value={value} onChange={onChange} containerProps={{ style: { height: height ? height : 500 } }} />

    }

  </InputFieldUI>

export default InputHtmlTextUI
